module.exports = {"451425100":"天等镇","451425101":"龙茗镇","451425102":"进结镇","451425103":"向都镇","451425104":"东平镇","451425105":"福新镇","451425200":"都康乡","451425201":"宁干乡","451425202":"驮堪乡","451425205":"进远乡","451425206":"上映乡","451425207":"把荷乡","451425208":"小山乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/451425.json
// module id = 2005
// module chunks = 0